import $ from "jquery";
import { loadPosts } from "../utils/fetch-posts";

$(function () {
  // On posts load more click

  $(".js-posts-load").on("click", function () {
    const postType = $(".js-posts-load").attr("data-post-type") ?? "post";
    loadPosts({
      page: $(".js-posts").attr("data-page"),
      postType,
    });
  });
});
